<style scoped="scoped" lang="scss"></style>

<template>
  <div ref="container" style="height:100%;">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane :label="$t('daiwoshenhe')" name="checkPending"> </el-tab-pane>
      <el-tab-pane :label="$t('woyishenhe')" name="checkFinish"> </el-tab-pane>
      <el-tab-pane :label="$t('wodeshenqing')" name="processMessage"> </el-tab-pane>
    </el-tabs>
    <div :style="{'height':pageHeight+'px'}">
      <component v-if="pageHeight!=0" :is="activeName"></component>
    </div>
  </div>
</template>

<script>
  import processMessage from '@@/pages/web/system/process/process_message/index.vue'
  import checkPending from '@@/pages/web/system/process/check_message/check_pending/index.vue'
  import checkFinish from '@@/pages/web/system/process/check_message/check_finish/index.vue'
  export default {
    name: "web_system_message_process_index",
    components:{
      processMessage,
      checkFinish,
      checkPending
    },
    mounted(){

    setTimeout(() => {
      this.pageHeight = this.$refs.container.offsetHeight - 41-15
    }, 200);
    },
    data(){
      return{
        activeName:"processMessage",
        pageHeight:0,
      }
    },methods:{
      handleClick(){

      }
    },
    activated(){
      if(this.$route.query.ativeName){
        this.activeName=this.$route.query.ativeName
      }else{
        this.activeName='checkPending';
      }


    }
  }
</script>
